import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const MobileIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-mobile-icon': true,
      [className]: className,
    })}
    name={IconNames.MOBILE}
    size={size}
    {...rest}
  />
);

MobileIcon.propTypes = {
  ...iconPropTypes,
};

MobileIcon.defaultProps = {
  ...iconDefaultProps,
};


export default MobileIcon;
